import { fetchLeaderboard } from 'api/firebase';
import { useQuery } from 'react-query';
import { Queries } from 'types/enum';

// TODO: Update type
export function useLeaderboard(
  chainId: number,
  rewardProgramAddress: string,
  search: string
) {
  return useQuery<any, Error>(
    [Queries.LEADERBOARD, chainId, rewardProgramAddress, search],
    () => fetchLeaderboard(chainId, rewardProgramAddress, search)
  );
}
